import { useEffect, useState } from "react";

const Loader = ({ fullscreen = false, size = 300, text = "" }) => {
  const [flip, setFlip] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFlip((prev) => !prev);
    }, 500); // flip speed
    return () => clearInterval(interval);
  }, []);

  // Same fullscreen wrapper you already use
  const wrapperStyle = fullscreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.3)",
        zIndex: 9999,
      }
    : {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      };

  return (
    <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-[99999]">

      <style>{`
  .json-flip {
    font-family: monospace;
    font-size: 42px;
    font-weight: 700;
    color: #ffffff;
    transition: transform 0.45s ease, opacity 0.45s ease;
    display: inline-block;
  }

  .flip {
    transform: rotateX(0deg);
    opacity: 1;
  }

  .flip-alt {
    transform: rotateX(180deg);
    opacity: 0.85;
  }
`}</style>

<div style={{ textAlign: "center" }}>
  <div className={`json-flip ${flip ? "flip" : "flip-alt"}`}>
    {flip ? "{}" : "{…}"}
  </div>
</div>

    </div>
  );
};

export default Loader;
